export default __webpack_public_path__ + "static/media/Leggings of Erlik.34e7d615.jpg";